import type { PairedCostAdjustmentType, ProductColor } from '@aloft/toolkit-shared';

import { selectAppliedADUAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectADUAdj.ts';
import { selectAppliedAtticAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectAtticAdjustment.ts';
import { selectAppliedBarnAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectBarnAdj.ts';
import { selectAppliedBasementAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectBasementAdj.ts';
import { selectAppliedBelowGradeBathsAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectBelowGradeBathsAdj.ts';
import { selectAppliedFireplaceAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectFireplaceAdjustment.ts';
import { selectAppliedGarageCarportAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectGarageCarportAdj.ts';
import { selectAppliedManualCostAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectManualCostAdj.ts';
import { selectAppliedPoolSpaAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectPoolSpaAdj.ts';
import { selectAppliedPorchPatioDeckAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectPorchPatioDeckAdj.ts';
import { selectAppliedShedAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectShedAdj.ts';
import { selectAppliedWorkshopAdjDisplay } from '../../../../redux/features/selectors/adjustmentSelectors/selectWorkshopAdj.ts';
import type { RootState } from '../../../../redux/types.ts';

type FeatureAdjustmentSelectors = {
  [key in PairedCostAdjustmentType]?: (
    state: RootState,
    id: string,
  ) =>
    | {
        value: string;
        color: ProductColor;
      }
    | undefined;
};

export const FEATURE_ADJUSTMENT_SELECTORS: FeatureAdjustmentSelectors = {
  basement: selectAppliedBasementAdjDisplay,
  bathBelowGrade: selectAppliedBelowGradeBathsAdjDisplay,
  garageCarport: selectAppliedGarageCarportAdjDisplay,
  porchPatioDeck: selectAppliedPorchPatioDeckAdjDisplay,
  pool: selectAppliedPoolSpaAdjDisplay,
  shed: selectAppliedShedAdjDisplay,
  workshop: selectAppliedWorkshopAdjDisplay,
  barn: selectAppliedBarnAdjDisplay,
  adu: selectAppliedADUAdjDisplay,
  attic: selectAppliedAtticAdjDisplay,
  fireplace: selectAppliedFireplaceAdjDisplay,
  manual: selectAppliedManualCostAdjDisplay,
};
